import { Title } from './Title';
export function SectionHeading(props) {
    return <Title appearance="section" as="h3" {...props}/>;
}
